import { render, staticRenderFns } from "./TrxDocument.vue?vue&type=template&id=12964c52"
import script from "./TrxDocument.vue?vue&type=script&lang=js"
export * from "./TrxDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports